import React from 'react'

const Footer = () => {
  return (
    <div className="text-xs text-white text-center py-8">
      &copy;2021. All rights reserved.
    </div>
  )
}

export default Footer
